<template>
  <button
    v-if="list && computedStations.length"
    type="button"
    class="g-btn g-btn--rounded g-btn--blue selective-survey-button"
    @click="surveyBtnClicked"
  >
    {{ $t('messages.sharedTexts.stations.stationSurvey') }} <font-awesome-icon :icon="['fas', 'chevron-right']" />
  </button>
</template>

<script>
import isEmpty from 'lodash/isEmpty'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import uniq from 'lodash/uniq'

export default {
  name: 'SelectiveSurveyButton',
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  props: {
    list: { // alarmlist data
      type: Array,
      default() {
        return []
      }
    },
    stations: { // actual list of stations
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {
    computedStations () { // Takes either a normal array of stations or an alarmlist array
      let stations = []

      if(this.stations && this.stations.length) {
        stations = this.stations
      } else if(this.list && this.list.length) {
        stations = this.list.map(item => item.stations.filter(station => parseInt(station.StId, 10) < 11000))
      }

      if(this.stations && stations.length) {
        stations = uniq(stations.flat().map(station => station.StId)).join(',')
      }

      return stations !== '' ? stations : []
    }
  },
  methods: {
    surveyBtnClicked() {
      this.$router.push(`/survey?stations=${this.computedStations}`)
    }
  }
}
</script>